<p-toast position="top-right"></p-toast>

<p-dialog [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [(visible)]="discardConfirmDialog"
          [style]="{ 'width': '665px', 'height': '200px', 'border-radius': '28px', 'position': 'relative', 'z-index': '11022' }">
    <ng-template pTemplate="header">
        <span class="discard-header">Discard changes?</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="discard-text">This will discard changes and cannot be reversed. Do you really</div>
        <div class="discard-text mb-5"> want to continue?</div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="btn-profile btn-danger-default mr-3" style="border-radius: 100px" (click)="discardConfirm()">Discard Changes</div>
        <div class="btn-profile btn-white btn-cancel" style="border: none" (click)="cancelDiscard()">Go Back</div>
    </ng-template>
</p-dialog>

<div class="spinner-container spinner-centered" *ngIf="loading">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="preview-label">Saving...</p>
</div>

    <mat-toolbar color="transparent" class="header-toolbar">

    <!-- Back Icon -->
    <button (click)="goBack()" mat-icon-button>
        <mat-icon>arrow_back</mat-icon>
    </button>

    <!-- Store Info -->
    <div class="store-info">
        <div class="store-name">{{selectedStore.Name}}</div>
        <div class="store-address">{{selectedStore.City}}</div>
    </div>

    <span class="spacer"></span>

    <!-- Status Section -->
    <div class="status-section">
        <mat-icon class="info-icon" matTooltip="Platform Status determines if this store is visible to customers.">info</mat-icon>

        <span class="status-label">Platform Status:</span>
        <mat-chip [matMenuTriggerFor]="publishMenu" color="accent" selected class="status-chip" [ngClass]="{'open' : selectedStore.PublishedStatus === 'Active'}">{{selectedStore.PublishedStatus === 'Inactive' ? 'Inactive' : 'Active' }}</mat-chip>
        <span class="status-label">Store Status:</span>
        <mat-chip [matMenuTriggerFor]="statusMenu" color="accent" selected class="status-chip" [ngClass]="{'open' : selectedStore.StatusName === 'Open'}">{{ selectedStore.StatusName }}</mat-chip>
        <mat-menu #statusMenu="matMenu">
            <button mat-menu-item (click)="onStoreStatusChange(false)">Open</button>
            <button mat-menu-item (click)="onStoreStatusChange(true)">Closed</button>
        </mat-menu>
        <mat-menu #publishMenu="matMenu">
            <button mat-menu-item (click)="setPublishedStatus(true)">Active</button>
            <button mat-menu-item (click)="setPublishedStatus(false)">Inactive</button>
        </mat-menu>
    </div>

    </mat-toolbar>

    <mat-tab-group (selectedTabChange)="onTabChange($event)" mat-stretch-tabs="false" mat-align-tabs="start" class="tab-group pt-3 pb-3" animationDuration="0ms">
        <mat-tab label="Inventory">
            <ng-template matTabContent>
                <store-inventory [store]="storeFullData" [merchantId]="selectedStore.MerchantId"></store-inventory>
            </ng-template>
        </mat-tab>
        <mat-tab label="Store Hours">
            <ng-template matTabContent>
                <store-hours-details [storeId]="selectedStore.Id" [storeData]="storeFullData"></store-hours-details>
            </ng-template>
        </mat-tab>
        <mat-tab label="Store Details">
            <ng-template matTabContent>
                <div class="store-view-tab-content mt-5">
                    <div class="tab-title" mat-dialog-title>{{modeName}}</div>
                    <ng-container *ngIf="!isEditMode">
                        <div class="preview-label mt-5">Store Name</div>
                        <div class="preview-text-field ml-3 mt-2">{{storeFullData?.Name}}</div>

                        <div class="preview-label mt-5">Store Address</div>
                        <div class="preview-text-field ml-3 mt-2">{{storeFullData?.Address}}</div>

                        <div class="preview-label mt-5">Store Type</div>
                        <div class="preview-text-field ml-3 mt-2">{{storeFullData.StoreTypeText}}</div>

                        <div class="preview-label mt-5">Location Details</div>
                        <div class="ml-3 mt-3">
                            <div class="preview-label mt-3">Brand</div>
                            <div class="preview-text-field ml-3 mt-2">{{storeFullData.Brand}}</div>

                            <div class="preview-label mt-3">Location Name(City)</div>
                            <div class="preview-text-field ml-3 mt-2">{{storeFullData.City}}</div>

                            <div class="preview-label mt-3">Location Type</div>
                            <div class="preview-text-field ml-3 mt-2">{{locationName}}</div>

                            <div class="preview-label mt-3">Serviceable Area (KM Radius)</div>
                            <div class="preview-text-field ml-3 mt-2">{{storeFullData.ServiceableAreaRadius}}</div>

                            <div class="preview-label mt-3">Postal Code</div>
                            <div class="preview-text-field ml-3 mt-2">{{storeFullData.PostalCode}}</div>

                            <div class="preview-label mt-3">Additional Details</div>
                            <div class="preview-text-field ml-3 mt-2">{{storeFullData.AddressDetails}}</div>
                        </div>

                        <div class="preview-label mt-5">Contact Information</div>
                        <div class="mt-3 ml-3">
                            <div class="preview-label">Store Email Address:</div>
                            <div class="preview-text-field ml-3 mt-2">{{storeFullData.Email}}</div>

                            <div class="preview-label mt-3">Phone Number:</div>
                            <div class="preview-text-field ml-3 mt-2">{{storeFullData.Phone}}</div>
                        </div>

                        <div class="preview-label mt-5">Store Photos:</div>
                        <img *ngIf="storeFullData.ImageUrl" class="preview-photo ml-3 mt-2" src="{{storeFullData.ImageUrl}}">
                    </ng-container>

                    <ng-container *ngIf="isEditMode">
                        <form [formGroup]="detailsForm" id="create-store-form">
                            <ng-template matStepLabel>Details</ng-template>

                            <mat-form-field appearance="fill" class="full-width p-2 mt-4">
                                <mat-label>Street Address</mat-label>
                                <input type="text"
                                        matInput
                                        formControlName="Address"
                                        [matAutocomplete]="streetAuto"
                                />
                                <mat-autocomplete
                                    #streetAuto="matAutocomplete"
                                    (optionSelected)="onOptionSelected($event)"
                                    [displayWith]="displayFn">
                                    <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">
                                        {{ option.description }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="detailsForm.get('Address')?.hasError('required')">
                                    This field is required.
                                </mat-error>
                                <mat-error *ngIf="detailsForm.get('Address')?.hasError('isDuplicate')">
                                    This location already exists in your store list.
                                </mat-error>
                                <mat-error *ngIf="detailsForm.get('Address')?.hasError('invalidAddress')">
                                    Invalid Address.
                                </mat-error>
                            </mat-form-field>

                            <div #mapContainer class="map"
                                [ngStyle]="{ height: (detailsForm.get('Address')?.invalid) ? '0' : '15rem' }"
                            ></div>

                            <mat-form-field [ngClass]="{'hidden': (detailsForm.get('Address')?.invalid)}" appearance="outline">
                                <mat-label>Serviceable Area (KM Radius)</mat-label>
                                <input matInput type="number" formControlName="Radius" />
                                <mat-error *ngIf="detailsForm.get('Radius')?.hasError('required')">
                                    This field is required.
                                </mat-error>
                            </mat-form-field>

                            <div class="labels">Location Details</div>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label>Brand</mat-label>
                                <input matInput placeholder="" formControlName="Brand" />
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label>Store Name</mat-label>
                                <input matInput placeholder="" formControlName="Name" required />
                                <mat-error *ngIf="detailsForm.get('Name')?.hasError('required')">
                                    Store name is required.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label>Location Type</mat-label>
                                <mat-select formControlName="LocationTypeId" [placeholder]="'(ex: ' + locationTypeList[0].name + ')'">
                                    <mat-option *ngFor="let type of locationTypeList"
                                        [value]="type.value">{{ type.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="detailsForm.get('LocationTypeId')?.hasError('required')">
                                    This field is required.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label>Additional Details</mat-label>
                                <input matInput placeholder="" formControlName="AddressDetails" required />
                                <mat-error *ngIf="detailsForm.get('AddressDetails')?.hasError('required')">
                                    Additional details are required.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label>City</mat-label>
                                <input matInput placeholder="" formControlName="City" />
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label>Postal Code</mat-label>
                                <input matInput placeholder="" formControlName="PostalCode" />
                            </mat-form-field>

                            <div class="labels">Location Photo (not published)</div>
                            <!-- Upload Section -->
                            <ng-container *ngIf="!detailsForm.get('ImageUrl')?.value; else filename">
                                <div (dragover)="onDragOver($event)"
                                        (dragleave)="onDragLeave($event)"
                                        (drop)="onFileDrop($event)"
                                        class="upload"
                                        [ngClass]="{ 'upload-error': detailsForm.get('ImageUrl')?.invalid && detailsForm.touched }">
                                    <p class="upload__hint">Drop files here to upload</p>

                                    <input type="file"
                                            class="upload__file-input"
                                            (change)="onFileSelected($event)"
                                            #fileUpload/>
                                    <button
                                            mat-button
                                            type="button"
                                            class="light-button"
                                            (click)="fileUpload.click()">
                                        Browse file
                                    </button>
                                </div>

                                <p class="upload-error-message">
                                    <ng-container *ngIf="locationPhotoFile?.hasError('filesize')">
                                        {{ locationPhotoFile?.errors?.['filesize'] }}
                                    </ng-container>
                                    <ng-container *ngIf="locationPhotoFile?.hasError('fileType')">
                                        {{ locationPhotoFile?.errors?.['fileType'] }}
                                    </ng-container>
                                </p>
                            </ng-container>
                            <ng-template #filename>
                                <div class="image-preview-container">
                                    <img
                                            [src]="detailsForm.get('ImageUrl')?.value"
                                            alt="Location Photo Preview"
                                            class="image-preview"
                                            (error)="onImageError($event)"
                                    />
                                    <button
                                            mat-icon-button
                                            color="warn"
                                            (click)="removeLocationPhoto()"
                                            class="remove-photo-btn">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            </ng-template>

                            <div class="labels">Contact Information</div>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label>Store Email Address</mat-label>
                                <input matInput placeholder="Store Email Address" formControlName="Email" required />
                                <mat-error *ngIf="detailsForm.get('Email')?.hasError('required')">
                                    Store email address is required.
                                </mat-error>
                                <mat-error *ngIf="detailsForm.get('Email')?.touched && detailsForm.get('Email')?.hasError('email')">
                                    Please enter a valid email address.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label>Store Phone Number</mat-label>
                                <input matInput placeholder="Store Phone Number" formControlName="Phone" required />
                                <mat-error *ngIf="detailsForm.get('Phone')?.hasError('required')">
                                    Store phone number is required.
                                </mat-error>
                                <mat-error *ngIf="detailsForm.get('Phone')?.touched && detailsForm.get('Phone')?.hasError('pattern')">
                                    Please enter a valid PH mobile number (e.g +639123456789).
                                </mat-error>
                            </mat-form-field>
                        </form>
                    </ng-container>

                    <div class="flex justify-content-end">
                        <button *ngIf="!isEditMode" mat-button type="button" (click)="editBtnClick()" class="btn-edit-store cursor-pointer">Edit</button>
                        <button *ngIf="isEditMode" mat-button type="button" (click)="goBack()" class="mr-4 btn-edit-store cursor-pointer">Cancel</button>
                        <button *ngIf="isEditMode" [ngClass]="{'btn-disabled': !detailsForm.dirty || detailsForm.invalid}" [disabled]="!detailsForm.dirty || detailsForm.invalid" mat-button type="button" (click)="editBtnClick()" class="btn-save-store cursor-pointer">Save</button>
                    </div>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab label="Employees">
            <ng-template matTabContent>
                <merchant-employees [merchantId]="storeFullData.MerchantId" [storeId]="selectedStore.Id"></merchant-employees>
            </ng-template>
        </mat-tab>
        <mat-tab label="Payout Details">
            <ng-template class="p-3" matTabContent>
                
                <div *ngIf="isLoadingPaymentCheck" class="text-center py-4">
                    <mat-spinner diameter="40"></mat-spinner>
                    <p class="mt-2">Checking payment details...</p>
                </div>

                @if (noInternetConnection) {
                <div
                    class="flex justify-content-center flex-wrap align-items-center h-30rem"
                >
                    <div class="flex flex-column">
                        <div class="flex align-items-center justify-content-center mb-2">
                            <p class="font-medium text-center">No Internet Connection</p>
                        </div>
                        <div class="text-center text-gray-600 mb-3">
                            Please check your internet connection and try again.
                        </div>
                        <button
                            mat-flat-button
                            color="primary"
                            (click)="checkInternetConnection(); checkExistingPaymentDetails()"
                            class="align-self-center"
                        >
                            <mat-icon>refresh</mat-icon>
                            Retry
                        </button>
                    </div>
                </div>
                } @if (noInternetConnection) {
                <!-- Connection status banner -->
                <div class="connection-status-banner">
                    <div class="flex align-items-center justify-content-between p-3" style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px; margin-bottom: 16px;">
                        <div class="flex align-items-center">
                            <mat-icon style="color: #856404; margin-right: 8px;">wifi_off</mat-icon>
                            <span style="color: #856404; font-weight: 500;">No Internet Connection - Showing cached data</span>
                        </div>
                        <button
                            mat-icon-button
                            (click)="checkInternetConnection(); checkExistingPaymentDetails()"
                            style="color: #856404;"
                            matTooltip="Retry connection"
                        >
                            <mat-icon>refresh</mat-icon>
                        </button>
                    </div>
                </div>
                }
                
                <ng-container *ngIf="!isLoadingPaymentCheck && !noInternetConnection">
                    <ng-container *ngIf="hasExistingPaymentDetails; else addPaymentForm">   
                        <merchant-payment-view [merchantId]="getMerchantId()" (hidePaymentGridViewEmit)="checkExistingPaymentDetails()"></merchant-payment-view>
                    </ng-container>
                    <ng-template #addPaymentForm>
                        <merchant-payment [merchantId]="getMerchantId()" (showPayoutData)="checkExistingPaymentDetails()"></merchant-payment>
                    </ng-template>
                </ng-container>
            </ng-template>
        </mat-tab>
        <mat-tab label="Settings">
            <ng-template matTabContent>
                <div class="store-view-tab-content mt-5">
                    <div class="tab-title" mat-dialog-title>{{modeName}}</div>
                    <ng-container *ngIf="!isEditMode">
                        <div class="flex">
                            <div class="w-50">
                                <div class="preview-label mt-5">Assigned Merchant</div>
                                <div class="preview-text-field ml-3 mt-2">{{merchantName}}</div>
                            </div>
                            <div>
                                <div class="preview-label mt-5">Store Type</div>
                                <div class="preview-text-field ml-3 mt-2">{{storeFullData?.StoreTypeText}}</div>
                            </div>
                        </div>

                        <div class="preview-label mt-5">Commission</div>
                        <div class="preview-text-field ml-3 mt-2">{{storeFullData?.Commission}}</div>

                        <div class="flex">
                            <div class="w-50">
                                <div class="preview-label mt-5">Minimum Order Amount</div>
                                <div class="preview-text-field ml-3 mt-2">{{storeFullData?.MinimalOrderAmount}}</div>
                            </div>
                            <div>
                                <div class="preview-label mt-5">Minimum Order Fee</div>
                                <div class="preview-text-field ml-3 mt-2">{{storeFullData?.MinimalOrderFee}}</div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="isEditMode">
                        <form [formGroup]="settingsForm" id="create-store-form">
                            <ng-template matStepLabel>Settings</ng-template>

                            <div class="preview-label mt-5 mb-4">Assigned Merchant</div>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label>Select Merchant</mat-label>
                                <mat-select formControlName="MerchantId" [placeholder]="'Please Select Merchant'">
                                    <mat-option *ngFor="let merchant of merchantsList" [value]="merchant.Id">
                                        {{ merchant.Name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="settingsForm.get('MerchantId')?.hasError('required')">
                                    Merchant is required.
                                </mat-error>
                            </mat-form-field>

                            <div class="preview-label mb-4">Settings</div>

                            <mat-form-field appearance="fill" class="w-50 p-2 percent-field">
                                <mat-label>Commission</mat-label>
                                <input matInput formControlName="Commission" required (focusout)="formatValue($event, 'Commission')"
                                       (input)="onInput($event)" [value]="commissionDisplayValue" />
                                <mat-error *ngIf="settingsForm.get('Commission')?.hasError('required')">
                                    Commission is required.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label>Promo Advertising Budget</mat-label>
                                <!--                  <div class="peso-sign" matPrefix>₱</div>-->
                                <input matInput formControlName="PromoAdvertisingBudget" required
                                />
                                <mat-error *ngIf="settingsForm.get('PromoAdvertisingBudget')?.hasError('required')">
                                    Promo Advertising Budget is required.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label class="ml-3">Minimum Order Amount</mat-label>
                                <div class="peso-sign" matPrefix>₱</div>
                                <input class="ml-5" matInput formControlName="MinimalOrderAmount" required (focusout)="formatValue($event, 'MinimalOrderAmount')"
                                       (input)="onInput($event)" [value]="amountDisplayValue" />
                                <mat-error *ngIf="settingsForm.get('MinimalOrderAmount')?.hasError('required')">
                                    Minimum Order Amount is required.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="w-50 p-2">
                                <mat-label class="ml-3">Minimum Order Fee</mat-label>
                                <div class="peso-sign" matPrefix>₱</div>
                                <input class="ml-5" matInput formControlName="MinimalOrderFee" required (focusout)="formatValue($event, 'MinimalOrderFee')"
                                       (input)="onInput($event)" [value]="feeDisplayValue" />
                                <mat-error *ngIf="settingsForm.get('MinimalOrderFee')?.hasError('required')">
                                    Minimum Order Fee is required.
                                </mat-error>
                            </mat-form-field>
                        </form>
                    </ng-container>

                    <div class="flex justify-content-end">
                        <button *ngIf="!isEditMode" mat-button type="button" (click)="editBtnClick()" class="btn-edit-store">Edit</button>
                        <button *ngIf="isEditMode" mat-button type="button" (click)="editBtnClick()" class="btn-save-store">Save</button>
                    </div>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>

<p-toast position="top-right"></p-toast>
